import { PageControl } from './main';

export class User {
    id: string;
    name: string;
    email: string;
    type: string;
    city: string;
    lastVisited: string;
    countryCode: string;
    phone: string;
    roles: string[];
    isConfirm: boolean;
    isBlock: boolean;
    companyName: string;
    role: string;
    profile: string;
    actualPlan: string;
    userId: string;

    manager: Manager = null;
    guestInformation: GuestCompleteInfo = null;


    get isSolutionProvider(): boolean {
        return this.roles && this.roles.indexOf(UserProfile.SOLUTION_PROVIDER) > -1;
    }

    get isPublicAdministrator(): boolean {
        return this.roles && this.roles.indexOf(UserProfile.PUBLIC_ADMINISTRATOR) > -1;
    }
}

export class Account {
    actualPlan: string;
    city: string;
    cityId?: string;
    companyManager: boolean;
    companyName: string;
    countryCode: string;
    email: string;
    isBlock: boolean;
    isConfirm: boolean;
    abntCommunicator: boolean;
    manager: {
        guests: {
            email: string;
            indicators: number;
            lastAcces: string;
            managerId: string;
            name: string;
            profile: string;
            role: string;
            userId: string;
        };
        billingSummary: {
            card: {
                brand: string;
                expMonth: number;
                expYear: number;
                last4Digits: string;
            };
            active: boolean;
            nextPaymentDate: Date;
            trialingUntil: Date;
            validUntil: Date;
            canceledAt: Date;
            plan: {
                id: string;
                name: string;
                price: {
                    amountCents: number;
                    currency: string;
                },
                planType: string;
            },
            address: {
                city: string;
                country: string;
                line1: string;
                line2: string;
                postalCode: string;
                state: string;
            },
            cpfOrCnpj: string;
        };
    };
    name: string;
    paymentVerified: number;
    phone: string;
    plan: string;
    planId: string;
    profile: string;
    propertyId: string;
    propertyIds?: string[];
    properties?: Array<{
        id: string;
        name: string;
        region?: string;
        country?: string;
    }>;
    propertyName: string;
    role: string;
    status: string;
    type: 'USER' | 'ADMIN' | 'PUBLIC_ADMINISTRATOR' | 'SOLUTION_PROVIDER' | 'CITIZEN' | 'GUEST' | 'OWNER' | 'PENDING_PAYMENT' | 'PENDING_BRIGHT_VERIFICATION' | 'ACTIVE' | 'BLOCKED' | 'PENDING_UPGRADE_PAYMENT';
    userId: string;
    verified: number
}

export class Manager {
    guests: GuestUser[];
    history: PaymentLog;
    paymentMethod: PaymentMethod;
    plan: string;
}

export class GuestUser {
    id: string;
    name: string;
}

export class UserGuest {
    acceptTerms: boolean;
    countryCode: string;
    email: string;
    password?: string;
    indicators: Array<any>;
    isManager: boolean;
    lastAccess: string;
    managerId: string;
    name: string;
    phone: string;
    profile: Array<any>;
    role: string;
    userId: string;
    permissions: Permissions;
}

export class PaymentLog {
    id: string;
    date: string;
    paymentMethodId: string;
    value: string;
    invoiceUrl: string;
}

export class PaymentMethod {
    displayNumber: string;
    holderName: string;
    paymentType: string;
}

export class GuestCompleteInfo {
    indicators: string[];
    profile: string[];
    userId: string;
}

export class UserSearchParams {
    active: boolean;
    plan: string;
    query: string;
    role: string;
    status: string;
    // planId: string;
    pageControl: PageControl = new PageControl;
}

export class RdContact {
    name: string;
    cidade: string;
    mobile_phone: string;
    email: string;
    perfil: string;
}

export enum UserProfile {
    CITIZEN = "CITIZEN",
    SOLUTION_PROVIDER = "SOLUTION_PROVIDER",
    PUBLIC_ADMINISTRATOR = "PUBLIC_ADMINISTRATOR"
}

export enum GuestPermissions {
    BASIC_INFO = "BASIC_INFO",
    PROFILE_INFORMATIONS = "PROFILE_INFORMATIONS"
}

export interface Permissions {
    editProfileInformation: boolean;
    areas: CityIndicators[];
}

export enum PlatformFeature {
    CITY_DIAGNOSIS = "CITY_DIAGNOSIS",
    SOLUTIONS_ROADMAP = "SOLUTIONS_ROADMAP",
    FEATURED_SOLUTIONS = "FEATURED_SOLUTIONS",
    OPPORTUNITIES_MAP = "OPPORTUNITIES_MAP",
    CITY_CERTIFICATION = "CITY_CERTIFICATION"
}

export enum CityIndicators {
    EDUCATION = 'EDUCATION',
    ENERGY = 'ENERGY',
    ECONOMY = 'ECONOMY',
    ENVIRONMENT = 'ENVIRONMENT',
    GOVERNANCE = 'GOVERNANCE',
    HEALTH = 'HEALTH',
    MOBILITY = 'MOBILITY',
    SECURITY = 'SECURITY',
    TECHNOLOGY = 'TECHNOLOGY',
    URBANISM = 'URBANISM'
}
